module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-37.86450504.png";